import i18next, { use as usei18next } from "i18next";
import { DateTime } from "luxon";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES_KEYS, detectLanguage } from "utils/language";
import enumEn from "./en/enum.json";
import errorEn from "./en/error.json";
import translationEn from "./en/translation.json";
import enumFr from "./fr/enum.json";
import errorFr from "./fr/error.json";
import translationFr from "./fr/translation.json";

export const resources = {
  en: { translation: translationEn, error: errorEn, enum: enumEn },
  fr: { translation: translationFr, error: errorFr, enum: enumFr },
};

const mediumDateTimeFormat: Intl.DateTimeFormatOptions = {
  month: "short",
  day: "numeric",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
  timeZoneName: "short",
};

function formatDate(value: unknown, lng: string | undefined, dateTimeFormat: Intl.DateTimeFormatOptions): string {
  if (value === undefined || value === null) return "";

  const date = new Date(value as string | number | Date);
  if (Number.isNaN(date.getTime())) {
    return value == null ? "-" : String(value);
  }

  return DateTime.fromJSDate(date)
    .setLocale(lng ?? DEFAULT_LANGUAGE)
    .toLocaleString(dateTimeFormat);
}

void usei18next(initReactI18next).init({
  lng: detectLanguage(),
  supportedLngs: SUPPORTED_LANGUAGES_KEYS,
  defaultNS: "translation",
  ns: ["translation", "error", "enum"],
  nonExplicitSupportedLngs: true, // Allows "en-US" and "en-UK" to be implicitly supported as "en"
  fallbackLng: DEFAULT_LANGUAGE,
  debug: false,
  initAsync: false,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources,
});

// i18next v26 removed interpolation.format — register custom formatters after init
i18next.services.formatter?.add("number", (value) => {
  if (value === undefined || value === null) return "";
  return value.toLocaleString(DEFAULT_LANGUAGE);
});
i18next.services.formatter?.add("mediumDate", (value, lng) => formatDate(value, lng, DateTime.DATE_MED));
i18next.services.formatter?.add("mediumDateTime", (value, lng) => formatDate(value, lng, mediumDateTimeFormat));
